<!-- 銀行綁定限制說明：/bank_restriction -->
<template>
  <div class="layout_wrapper">
    <div class="container_wrapper">
      <h3 class="page_main_title">
        銀行帳戶綁定限制
      </h3>

      <div class="table_wrapper">
        <table>
          <tr>
            <th>{{ tableTitle.bank_name }}</th>
            <th>{{ tableTitle.description }}</th>
          </tr>

          <tr
            v-for="(content, key) in tableContent"
            :key="key"
          >
            <td>{{ content.bank_name }}</td>
            <td>
              <p
                v-for="(desc, idx) in content.description.split('\n')"
                :key="idx"
                class="desc_para"
              >
                {{ desc }}
              </p>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <component :is="dialogName" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { AppDialog } from '@/components/Modal/';
import { getBankRestriction } from '@/libs/API/apis';
import useCommon from '@/libs/globalComposition';

export default {
  name: 'BankRestriction',
  components: {
    AppDialog
  },
  setup () {
    const { dialogName } = useCommon();

    const tableTitle = ref({});
    const tableContent = ref([]);

    onMounted(() => {
      getBankRestriction()
        .then((res) => {
          tableTitle.value = res.shift();
          tableContent.value = res;
        });
    });

    return {
      dialogName,
      tableTitle,
      tableContent
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';
@import '@/scss/common/layout.scss';

.layout_wrapper {
  .table_wrapper {
    table {
      border-collapse: collapse;
      width: 100%;

      tr {
        th,
        td {
          padding: 20px 30px;
        }

        th {
          @include font-size-16;

          background: $primary_color;
          border: 2px solid $primary_color;
          color: $black;
          font-weight: 500;
          letter-spacing: 1.07px;
          line-height: 20px;
          text-align: center;
        }

        td {
          @include font-size-16;

          border: 2px solid $mono_30;
          color: $mono_80;
          letter-spacing: 0.8px;

          &:not(:last-child) {
            color: $black;
            text-align: center;
          }

          .desc_para {
            margin: 2px 0px;
          }
        }
      }
    }
  }
}

@include RWD_414 {
  #app .layout_wrapper {
    .table_wrapper {
      table {
        tr {
          th,
          td {
            padding: 20px;
          }
        }
      }
    }
  }
}
</style>
